import { equals } from 'ramda';
import LandingPage from '../../pages/Landing/Loadable';
import events from '../events';
import ducks from '../../ducks';
import { ERROR_CODES } from '../../enums';
import { getActionsFromDucks } from '../utils';
import { getErrorCode } from '../../selectors/error';
import { isRequestError403, isRequestError404 } from '../../utils/error';
import { isMissionEnded, isMissionInProgress } from '../../utils/coreApi';
import {
  getPreviousClaimId,
  getPreviousMissionId,
  getIsClaimNotDisplayed,
  getIsNonEditableClaim,
} from '../../selectors/coreApi';
import { APPROVED, AUTH_ERROR, AUTHENTICATED, CLAIM_LOADED, MISSION_LOADED, REQUEST_ERROR } from '../../ducks/coreApi';
import { getIsPublicApiV1, getIsPublicApiV4, getIsPublicApiV5 } from '../../selectors/settings';
import states from '../states';
import { mainWorkflow, errorWorkflow } from './main';

const actions = getActionsFromDucks(ducks);

const computeInitialState = state => {
  if (getPreviousClaimId(state) && getPreviousMissionId(state)) return states.LANDING_SESSION;
  return states.VOICE_EXIT;
};

const config = {
  key: 'drsa',
  computeInitialState,
  states: {
    ...mainWorkflow,
    [states.LANDING_SESSION]: {
      component: LandingPage,
      on: {
        [events.START]: {
          target: states.LANDING_SESSION,
          actions: [actions.coreApi.authenticate],
        },
        [APPROVED]: {
          target: states.LANDING_SESSION,
          actions: [actions.coreApi.loadClaimById],
        },
        [AUTHENTICATED]: {
          target: states.LANDING_SESSION,
          actions: [actions.coreApi.loadClaimById],
        },
        [CLAIM_LOADED]: [
          {
            cond: state => (getIsPublicApiV4(state) || getIsPublicApiV5(state)) && getIsNonEditableClaim(state),
            target: states.PREVIOUS_CLAIM_HANDLING,
          },
          {
            cond: state => (getIsPublicApiV4(state) || getIsPublicApiV5(state)) && getIsClaimNotDisplayed(state),
            target: states.VOICE_EXIT,
          },
          {
            cond: getIsPublicApiV1,
            target: states.LANDING_SESSION,
            actions: [actions.coreApi.searchMissionByPreviousIdV1],
          },
        ],
        [MISSION_LOADED]: [
          {
            target: states.MISSION_MONITORING,
            cond: isMissionInProgress,
            actions: [actions.coreApi.startMissionMonitoring],
          },
          {
            target: states.END_MISSION,
            cond: isMissionEnded,
          },
        ],
        [REQUEST_ERROR]: [
          {
            cond: state =>
              (getIsPublicApiV4(state) || getIsPublicApiV5(state)) &&
              ((isRequestError403(state) && equals(getErrorCode(state), ERROR_CODES.RESOURCE_ACCESS_ISSUE)) ||
                (isRequestError404(state) && equals(getErrorCode(state), ERROR_CODES.CLAIM_NOT_FOUND))),
            target: states.VOICE_EXIT,
          },
          ...errorWorkflow(AUTH_ERROR),
        ],
      },
    },
  },
};

export default config;
